var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.192 18.815a8 8 0 1 1 2.217-2.026l.87.87a1.5 1.5 0 0 1-2.122 2.12l-.965-.964zm.06-4.183a5 5 0 1 0-2.28 1.964l-1.058-1.059a1.5 1.5 0 1 1 2.122-2.121l1.216 1.216z",
    fill: "#BE69C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionActive);
export default __webpack_public_path__ + "static/media/question_active.20f5fec61edcc9e7b8defa6239fac2ae.svg";
export { ForwardRef as ReactComponent };